import { notification, Typography } from 'antd';
import type { NotificationInstance, ArgsProps } from 'antd/es/notification/interface';
import React, { FC, ReactNode, useEffect } from 'react';

let notificationInstance: NotificationInstance | null = null;

export const setNotificationInstance = (api: NotificationInstance): void => {
    notificationInstance = api;
};

export const getNotificationInstance = (): NotificationInstance | null => {
    if (!notificationInstance) {
        console.warn('notificationInstance не инициализирован');
    }
    return notificationInstance;
};

export const notifySuccess = (
    description: ReactNode,
    options?: { message?: string; key?: string; duration?: number },
) => {
    const key = options?.key ?? `success-${Date.now()}`;
    getNotificationInstance()?.success({
        key,
        message: options?.message ?? 'Успех',
        description,
        placement: 'topRight',
        duration: options?.duration ?? 6,
    } as ArgsProps);
    return key;
};

export const closeNotification = (key: string) => {
    getNotificationInstance()?.destroy(key);
};

/** Кликабельная строка внутри success-баннера */
export const NotifyActionLink: FC<{
    children: ReactNode;
    onClick: () => void;
}> = ({ children, onClick }) => (
    <Typography.Link
        onClick={(event) => {
            event.preventDefault();
            onClick();
        }}
        style={{ display: 'block', marginTop: 4 }}
    >
        {children}
    </Typography.Link>
);

interface NotificationProviderProps {
    children: ReactNode;
}

export const NotificationProvider: FC<NotificationProviderProps> = ({ children }) => {
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        setNotificationInstance(api);
    }, [api]);

    return (
        <>
            {contextHolder}
            {children}
        </>
    );
};
